import { Link } from 'react-router-dom';
import { ChevronRight, Loader2 } from 'lucide-react';
import { useBlogPosts } from '../hooks/useBlogPosts';

interface RelatedBlogPostsProps {
  ssw: number;
  limit?: number;
  showHeader?: boolean;
}

export function RelatedBlogPosts({ ssw, limit = 3, showHeader = true }: RelatedBlogPostsProps) {
  const { posts, isLoading, error } = useBlogPosts({ ssw, limit });

  // Don't render anything if no posts
  if (!isLoading && posts.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {showHeader && (
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-white">Passende Artikel</h3>
          {posts.length > 0 && (
            <Link
              to="/blog"
              className="text-sm text-pp-orange hover:underline flex items-center gap-1"
            >
              Alle Artikel
              <ChevronRight className="w-4 h-4" />
            </Link>
          )}
        </div>
      )}

      {isLoading ? (
        <div className="flex items-center justify-center py-8">
          <Loader2 className="w-6 h-6 animate-spin text-white" />
        </div>
      ) : error ? (
        <div className="text-sm text-white/50 py-4 text-center">
          {error}
        </div>
      ) : (
        <div className="space-y-3">
          {posts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="block glass-effect rounded-[15px] p-4 hover:bg-white/15 transition-all"
            >
              <div className="flex gap-3">
                {post.image_url && (
                  <div className="w-16 h-16 rounded-[10px] overflow-hidden flex-shrink-0">
                    <img
                      src={post.image_url}
                      alt={post.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  {post.category && (
                    <span className="inline-block text-xs font-medium px-2 py-0.5 bg-pp-teal border border-white/25 rounded-[5px] text-white mb-1">
                      {post.category.name}
                    </span>
                  )}
                  <h4 className="font-medium text-white text-sm line-clamp-2">
                    {post.title}
                  </h4>
                </div>
                <ChevronRight className="w-4 h-4 text-pp-orange flex-shrink-0 self-center" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
